export const GET_OTP = "GET_OTP";
export const GET_LOGIN = "GET_LOGIN";
export const LOGOUT = "LOGOUT";
